module.exports = __webpack_public_path__ + "static/media/fo.375ebd5e.svg";